<template>
	<v-dialog
		v-model="dialog"
		max-width="500"
	>
		<template #activator="{ props }">
			<v-btn
				variant="plain"
				v-bind="props"
				class="text-none pl-1 pr-1"
			>
				<v-icon
					color="primary"
					icon="$info"
				/>
				<translate>Where can I find the purchase price?</translate>
			</v-btn>
		</template>

		<v-card>
			<v-card-title>
				<translate>
					Purchase price
				</translate>
			</v-card-title>
			<v-card-text>
				<v-list>
					<v-list-subheader>
						<translate>Where can I find the purchase price?</translate>
					</v-list-subheader>
					<v-list-item
						v-for="(item, i) in eanList"
						:key="i"
					>
						{{ item.text }}
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="primary"
					@click="dialog=false"
				>
					<translate>Okay</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'PurchasePriceInfoDialog',

	data () {
		return {
			dialog: false
		};
	},

	computed: {
		eanList () {
			return [
				{
					text: this.$gettext('Specify the purchase price (including VAT).')
				},
				{
					text: this.$gettext('You can find the purchase price on your invoice.')
				},
				{
					text: this.$gettext('Note: if you purchased your device with a subscription, there is ' +
						'often no separate device price on the invoice. You should look at your provider\'s ' +
						'contract instead.')
				},
			];
		}
	}

};
</script>
